import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FilterButtonWrapper, FilterButton, FilterDropdownContainer } from 'components/filters/FilterElements';
import useOutsideClick from 'hooks/useOutsideClick';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FilterDropdownButtonProps {
  activeFilterCount: number;
  children: ReactNode;
}

export const FilterDropdownButton = ({ activeFilterCount, children }: FilterDropdownButtonProps) => {
  const { t } = useTranslation();
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const filterDropdownRef = useOutsideClick<HTMLDivElement>(() => setShowFilterDropdown(false));

  return (
    <FilterButtonWrapper ref={filterDropdownRef}>
      <FilterButton $hasActiveFilters={activeFilterCount > 0} onClick={() => setShowFilterDropdown(!showFilterDropdown)}>
        <FontAwesomeIcon icon={faFilter} />
        {t('Filter')}
        {activeFilterCount > 0 && ` (${activeFilterCount})`}
      </FilterButton>
      {showFilterDropdown && <FilterDropdownContainer>{children}</FilterDropdownContainer>}
    </FilterButtonWrapper>
  );
};
